// extracted by mini-css-extract-plugin
export default {"projectDetails":"Pages_projectDetails__Tx65O"};